import React, { useEffect, useState, useRef } from "react";
import "./CustomPopUp.css";
import ABCarousel from "../ABCarousel";
import { getCarousel } from "../../Actions/carouselAction";
import { useDispatch, useSelector } from "react-redux";
import LoaderOnlySpinner from "./loaderOnlySpinner";
const CustomPopUp = React.forwardRef((props, ref) => {

  const dispatch = useDispatch();

  const { showModalBox, record, title } = props;
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
     
      dispatch(getCarousel(record));
    };

    fetchData();
  }, []);

  const storeCarouselData = useSelector((state) => state.carousel);
  //const dispatch = useDispatch();
  const { carouselData, loading, error } = storeCarouselData;

  const [sliderData, setSliderData] = useState([]);

    useEffect(() => {

      console.log(carouselData.data);

    if (typeof carouselData.data !== "undefined" && carouselData.data !== null) {

      let arr = [];

      Object.entries(carouselData.data).map(([key, value]) => {
        
        arr.push({image:value.preview_key,id:value.case_document_id});

      });

      // Object.entries(carouselData.data).map()
       setSliderData(arr);
    }else{
      setSliderData([]);
    }
  }, [carouselData, storeCarouselData]);

  useEffect(() => {
    if (typeof loading !== "undefined" && loading !== null) {
      if(loading === true){
        setIsLoading(true);
        }else{ setIsLoading(false);}
      
    }
  }, [carouselData]);

 
  // const {
  //   ref1,
  //   ref2,
  //   ref3,
  //   ref4,
  //   ref5,
  //   ref6,
  //   ref7,
  //   ref8,
  //   ref9,
  //   ref10,
  //   ref11,
  //   ref12,
  //   ref13,
  //   ref14,
  //   ref15,
  // } = ref;

 

  // const [selectedModeValue, setSelectedModeValue] = useState(
  //   modeValue.current.value
  // );

  // useEffect(() => {
  //   setSelectedModeValue(modeValue.current.value);
  // }, [modeValue.current.value]);

  const closePopupHandler = () => {
    props.closePopup();
  };
  

  // let title;
  // if (selectedModeValue === "1") {
  //   title = "Enter DD Details";
  // } else if (selectedModeValue === "2") {
  //   title = "Online Payment";
  // } else if (selectedModeValue === "3") {
  //   title = "Payment Method: NEFT";
  // } else if (selectedModeValue === "4") {
  //   title = "Payment Method: Challan";
  // }

  const reRender = () => {
    if(props?.hasOwnProperty('reRenderAgain')){
      props.reRenderAgain();
    }
 };


  return (
    <>
      <div
        className={
          "cstm-popup-dialog " + (showModalBox === 1 ? "show" : "hidden")
        }
        onClick={closePopupHandler}
      >
        
        <div
          className="cstm-popup"
          onClick={(e) => {
            // do not close modal if anything inside modal content is clicked
            e.stopPropagation();
          }}
        >
          <div className="cstm-popup-header">
            <h6 className="m-0">{title}</h6>
            <span className="cstm-popup-close-btn" onClick={closePopupHandler}>
              &times;
            </span>
          </div>
          <div className="cstm-popup-body p-3">

          {isLoading && <LoaderOnlySpinner /> }

          {sliderData.length > 0 ? (
            
          <ABCarousel items={sliderData} record={record} reRenderAgain={reRender} uploadCallback={props?.uploadCallback}/>
          ) : (
            <>
              {/* <center>No item found</center> */}
              
            </>
          )}
            </div>
        </div>
      </div>
    </>
  );
});

export default CustomPopUp;
